module.exports = __webpack_public_path__ + "media/images/home/demo_right2-6e7f2278682e0e56eba4e93b6d73d982.png";